import { render, staticRenderFns } from "./GallerySide.vue?vue&type=template&id=39e1e74b&scoped=true&"
import script from "./GallerySide.vue?vue&type=script&lang=js&"
export * from "./GallerySide.vue?vue&type=script&lang=js&"
import style0 from "./GallerySide.vue?vue&type=style&index=0&id=39e1e74b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e1e74b",
  null
  
)

export default component.exports